<template>
  <div
    ref="tmDraggable"
    class="draggable"
    :style="TmDraggableStyle"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @click.stop="handleClickDraggable"
    @contextmenu="handleContextMenu"
    :class="[isMultipleComponent && 'multipleClass']"
  >
    <div class="component-wrapper">
      <slot />
    </div>
    <div
      v-if="!preview"
      ref="leftTop"
      :style="
        conf.type !== 'TumengPriceTag' && conf.type !== 'TumengAd'
          ? leftTopCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="rightTop"
      :style="
        conf.type !== 'TumengPriceTag' && conf.type !== 'TumengAd'
          ? rightTopCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="leftBottom"
      :style="
        conf.type !== 'TumengPriceTag' && conf.type !== 'TumengAd'
          ? leftBottomCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="rightBottom"
      :style="
        conf.type !== 'TumengPriceTag' && conf.type !== 'TumengAd'
          ? rightBottomCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="top"
      :style="
        conf.type !== 'TumengPriceTag' &&
        conf.type !== 'TumengAd' &&
        conf.type !== 'TumengQRCode'
          ? topCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="rightMiddle"
      :style="
        conf.type !== 'TumengPriceTag' &&
        conf.type !== 'TumengAd' &&
        conf.type !== 'TumengQRCode'
          ? rightMiddleCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="bottom"
      :style="
        conf.type !== 'TumengPriceTag' &&
        conf.type !== 'TumengAd' &&
        conf.type !== 'TumengQRCode'
          ? bottomCircle
          : defalutCircle
      "
    ></div>
    <div
      v-if="!preview"
      ref="leftMiddle"
      :style="
        conf.type !== 'TumengPriceTag' &&
        conf.type !== 'TumengAd' &&
        conf.type !== 'TumengQRCode'
          ? leftMiddleCircle
          : defalutCircle
      "
    ></div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import { Drag } from "../../../utils/drag";
import { COMPONENT_TEXT } from "../../../utils/component-attribute";
import eventbus from "../../../utils/eventbus";

export default {
  name: "TumengDraggable",
  props: {
    // 组件的配置信息
    conf: {
      type: Object,
      default: () => {},
    },
    // 当前组件在当前页的位置
    idx: {
      type: Number,
      default: undefined,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 鼠标是不是在悬浮
      isFocus: false,
    };
  },
  computed: {
    pageScale() {
      return store.state.programInfo.scale;
    },
    isMultipleComponent() {
      return !!store.state.multipleComponentList.length;
    },
    shouldShowBorder() {
      // 多选边框显示
      if (
        (store.state.isCtrl || store.state.multipleComponentList.length) &&
        store.state.multipleComponentList.find(
          (com) => com === this.conf.componentId
        )
      ) {
        return true;
      }
      // 如果在预览或者在截图，那么不应该显示边线
      if (this.preview || store.state.isScreenshotting) {
        return false;
      }
      // 如果没有获得焦点 并且 组件没有被选中，那么不应该显示边线
      return !(
        !this.isFocus &&
        (!store.state.activeComponent ||
          store.state.activeComponent.componentId !== this.conf.componentId)
      );
    },
    // 组件的样式
    TmDraggableStyle() {
      let borderRadiusValue = "";
      if (this.conf.borderRadius) {
        const { borderRadius } = this.conf;
        borderRadiusValue = `${borderRadius.leftTop}px ${borderRadius.rightTop}px ${borderRadius.rightBottom}px ${borderRadius.leftBottom}px`;
      }
      const style = {
        position: "absolute",
        left: this.conf.left + "px",
        top: this.conf.top + "px",
        boxSizing: "border-box",
        width: this.conf.width + "px",
        height: this.conf.height + "px",
        zIndex: this.conf.zIndex,
        transform: this.conf.rotate
          ? "rotate(" + this.conf.rotate + "deg)"
          : "rotate(0deg)",
        transformOrigin: "center center",
      };

      // 正在截图的时候不能显示border。   如果组件被选中了 或者 鼠标悬浮在组件上边 显示蓝色边线
      if (this.shouldShowBorder) {
        style.border = "1px dashed #0099ff";
      }

      // 如果是文字要加背景
      if (this.conf.type === COMPONENT_TEXT) {
        style.backgroundColor = this.conf.hide ? "" : this.conf.bgColor;
        style.borderRadius = borderRadiusValue;
        if (this.conf.borderWidth && this.conf.borderColor) {
          style.border = `${this.conf.borderWidth}px solid ${this.conf.borderColor}`;
        }
      }
      return style;
    },
    // 左上角的圆点样式
    leftTopCircle() {
      const style = this.getBasicCircleStyle();
      style.left = "-6px";
      style.top = "-6px";
      style.cursor = "nwse-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    defalutCircle() {
      const style = this.getBasicCircleStyle1();
      style.cursor = "nwse-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 右上角的圆点样式
    rightTopCircle() {
      const style = this.getBasicCircleStyle();
      style.right = "-6px";
      style.top = "-6px";
      style.cursor = "nesw-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 左下角的圆点样式
    leftBottomCircle() {
      const style = this.getBasicCircleStyle();
      style.left = "-6px";
      style.bottom = "-6px";
      style.cursor = "nesw-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 右下角的圆点样式
    rightBottomCircle() {
      const style = this.getBasicCircleStyle();
      style.right = "-6px";
      style.bottom = "-6px";
      style.cursor = "nwse-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 上边的原点样式
    topCircle() {
      const style = this.getBasicCircleStyle();
      style.left = "calc(50% - 6px)";
      style.top = "-6px";
      style.cursor = "ns-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 右边中间的样式
    rightMiddleCircle() {
      const style = this.getBasicCircleStyle();
      style.top = "calc(50% - 6px)";
      style.right = "-6px";
      style.cursor = "ew-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 底部的样式
    bottomCircle() {
      const style = this.getBasicCircleStyle();
      style.bottom = "-6px";
      style.left = "calc(50% - 6px)";
      style.cursor = "ns-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
    // 左边中间的样式
    leftMiddleCircle() {
      const style = this.getBasicCircleStyle();
      style.top = "calc(50% - 6px)";
      style.left = "-6px";
      style.cursor = "ew-resize";

      // 如果鼠标悬浮在组件上边 或者选中了组件显示改变大小和位置的按钮
      if (this.shouldShowBorder) {
        style.display = "block";
      } else {
        style.display = "none";
      }
      return style;
    },
  },
  watch: {
    pageScale(val) {
      console.log("视图缩放了", val);
      this.init();
    },
  },
  mounted() {
    if (!this.preview && !this.isScreenshotting) {
      this.init();
    }
  },
  methods: {
    init() {
      if (
        !this.$refs.tmDraggable ||
        !this.$refs.leftTop ||
        !this.$refs.rightTop ||
        !this.$refs.leftBottom ||
        !this.$refs.rightBottom ||
        !this.$refs.top ||
        !this.$refs.rightMiddle ||
        !this.$refs.bottom ||
        !this.$refs.leftMiddle
      ) {
        return setTimeout(this.init, 1);
      }

      const _this = this;
      // console.log(store.state.programInfo)
      // 让draggable组件可以被自由拖动
      new Drag(
        _this.$refs.tmDraggable,
        store.state.programInfo.scale,
        function (left, top) {
          // console.log(left, top)
          if (store.state.multipleComponentList.length) {
            store.updataMultipleComponent(left, top);
          }
          // console.log("=======");
          // console.log(_this.conf);
          // 色块 文本旋转时 时间旋转时 图片旋转时
          if (
            _this.conf.type == "TumengBlock" ||
            (_this.conf.type == "TumengText" && 0 < _this.conf.rotate && _this.conf.rotate < 360) ||
            (_this.conf.type == "TumengMultiImg" && 0 < _this.conf.rotate && _this.conf.rotate < 360) ||
            (_this.conf.type == "TumengTime" && 0 < _this.conf.rotate && _this.conf.rotate < 360)
          ) {
            // console.log("可以超出画布");
            const Maximum =
              _this.conf.width >= _this.conf.height
                ? parseInt(_this.conf.width)
                : parseInt(_this.conf.height);
            if (left < 0 - Maximum) {
              left = 0 - Maximum;
            }
            if (top < 0 - Maximum) {
              top = 0 - Maximum;
            }
            if (
              left + parseInt(_this.conf.width) >
              parseInt(store.state.programInfo.width) + Maximum
            ) {
              left =
                parseInt(store.state.programInfo.width) +
                Maximum -
                parseInt(_this.conf.width);
            }
            if (
              top + parseInt(_this.conf.height) >
              parseInt(store.state.programInfo.height) + Maximum
            ) {
              top =
                parseInt(store.state.programInfo.height) +
                Maximum -
                parseInt(_this.conf.height);
            }
          } else {
            // region 不能超过边界
            if (left < 0) {
              left = 0;
            }
            if (top < 0) {
              top = 0;
            }
            if (
              left + parseInt(_this.conf.width) >
              store.state.programInfo.width
            ) {
              left = store.state.programInfo.width - parseInt(_this.conf.width);
            }
            if (
              top + parseInt(_this.conf.height) >
              store.state.programInfo.height
            ) {
              top =
                store.state.programInfo.height - parseInt(_this.conf.height);
            }
          }

          // endregion
          if (!store.state.activeComponent) {
            store.updateActiveComponentIdx(_this.idx);
          }
          // 拖拽之后要把信息同步到节目中
          store.state.activeComponent.left = left;
          store.state.activeComponent.top = top;
        },
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("move");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 让组件可以被改变大小 拖拽左上角
      this.handleLeftTopDrag(
        _this.$refs.leftTop,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("nwse-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 让组件可以被改变大小 拖拽右上角
      this.handleRightTopDrag(
        _this.$refs.rightTop,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("nesw-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 让组件可以被改变大小 拖拽左下角
      this.handleLeftBottomDrag(
        _this.$refs.leftBottom,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("nesw-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 让组件可以被改变大小 拖拽右下角
      this.handleRightBottomDrag(
        _this.$refs.rightBottom,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("nwse-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 拖拽中间顶部的圆圈
      this.handleTopDrag(
        _this.$refs.top,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("ns-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 拖拽右侧中间的圆圈
      this.handleRightMiddleDrag(
        _this.$refs.rightMiddle,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("ew-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 拖拽中间底部的圆圈
      this.handleBottomDrag(
        _this.$refs.bottom,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("ns-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );

      // 拖拽左侧中间的圆圈
      this.handleLeftMiddleDrag(
        _this.$refs.leftMiddle,
        this.$refs.tmDraggable,
        () => {
          store.updateActiveComponentIdx(_this.idx);
          store.updateCursor("ew-resize");
        },
        () => {
          store.updateCursor("default");
        }
      );
    },

    // 右击控件
    handleContextMenu(ev) {
      if (!this.preview && !store.state.isScreenshotting) {
        ev = ev || window.event;
        ev.preventDefault();

        store.updateActiveComponentIdx(this.idx);
        store.updateCtxMenuArgs(true, ev.clientX, ev.clientY);
      }
    },

    // 鼠标进入组件触发
    handleMouseEnter() {
      if (!this.preview && !store.state.isScreenshotting) {
        this.isFocus = true;
      }
    },

    // 鼠标移出组件触发
    handleMouseLeave() {
      if (!this.preview && !store.state.isScreenshotting) {
        this.isFocus = false;
      }
    },

    // 点击组件触发
    handleClickDraggable(ev) {
      ev = ev || window.event;
      ev.stopPropagation();
      if (store.state.isCtrl) {
        store.addComponentForMultiple(this.idx);
        return;
      }
      if (
        store.state.multipleComponentList.length &&
        !store.state.multipleComponentList.find(
          (com) => com === this.conf.componentId
        )
      ) {
        store.clearComponentForMultiple();
      }

      if (!this.preview && !store.state.isScreenshotting) {
        store.updateActiveComponentIdx(this.idx);
      }
      if (this.conf.type === COMPONENT_TEXT) {
        eventbus.$emit("click-component", this.conf.id);
      }

      if (this.conf.interact && this.conf.interact.type) {
        eventbus.$emit("interact-click", JSON.parse(JSON.stringify(this.conf)));
      }
    },

    // 得到四个角的圆圈的基本样式
    getBasicCircleStyle() {
      const scale = 1.0 / store.state.programInfo.scale;
      return {
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        position: "absolute",
        border: "1px solid #0099ff",
        transform: `scale(${scale})`,
      };
    },
    getBasicCircleStyle1() {
      const scale = 1.0 / store.state.programInfo.scale;
      return {
        width: "0px",
        height: "0px",
        borderRadius: "50%",
        position: "absolute",
        border: "0px solid #0099ff",
        transform: `scale(${scale})`,
      };
    },

    // 把元素的属性转换为数字。例如：100px转换为100
    getPropByStr(str) {
      return Number.parseInt(str.substring(0, str.length - 2));
    },

    // 让左上角的圆圈可以改变组件大小和位置
    handleLeftTopDrag(leftTop, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      leftTop.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;
        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          const dy = ev.clientY - startY;
          startX = ev.clientX;
          startY = ev.clientY;

          let left =
            _this.getPropByStr(dragDiv.style.left) +
            parseInt(dx / store.state.suitableScale);
          let top =
            _this.getPropByStr(dragDiv.style.top) +
            parseInt(dy / store.state.suitableScale);
          let width =
            _this.getPropByStr(dragDiv.style.width) -
            parseInt(dx / store.state.suitableScale);
          let height =
            _this.getPropByStr(dragDiv.style.height) -
            parseInt(dy / store.state.suitableScale);

          // 不能超过左边界上边界 如果超出边界直接返回
          if (left < 0 || top < 0) {
            return;
          }

          // 宽高不能小于1
          if (width < 1 || height < 1) {
            return;
          }
          if (store.state.activeComponent.type === "TumengQRCode") {
            if (Math.abs(dx) >= Math.abs(dy)) {
              height = width;
              top =
                _this.getPropByStr(dragDiv.style.top) +
                parseInt(dx / store.state.suitableScale);
            } else {
              width = height;
              left =
                _this.getPropByStr(dragDiv.style.left) +
                parseInt(dy / store.state.suitableScale);
            }
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.left = left;
          // console.group('=========监控图片拖拽')
          // console.log(top)

          store.state.activeComponent.top = top;
          store.state.activeComponent.width = width;
          store.state.activeComponent.height = height;
          // console.log(store.state.activeComponent)
          // console.groupEnd()
        }

        function moveEnd() {
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 让右上角的圆圈可以改变组件大小和位置
    handleRightTopDrag(rightTop, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      rightTop.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;
        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          const dy = ev.clientY - startY;
          startX = ev.clientX;
          startY = ev.clientY;

          let left = _this.getPropByStr(dragDiv.style.left);
          let top =
            _this.getPropByStr(dragDiv.style.top) +
            parseInt(dy / store.state.suitableScale);
          let width =
            _this.getPropByStr(dragDiv.style.width) +
            parseInt(dx / store.state.suitableScale);
          let height =
            _this.getPropByStr(dragDiv.style.height) -
            parseInt(dy / store.state.suitableScale);

          // 不能超过上边界下边界
          if (top < 0 || height < 0) {
            return;
          }

          // 不能超过左边界右边界
          if (width < 1 || left + width > store.state.programInfo.width) {
            return;
          }

          if (store.state.activeComponent.type === "TumengQRCode") {
            if (Math.abs(dx) >= Math.abs(dy)) {
              height = width;
              top =
                _this.getPropByStr(dragDiv.style.top) -
                parseInt(dx / store.state.suitableScale);
            } else {
              width = height;
              top =
                _this.getPropByStr(dragDiv.style.top) +
                parseInt(dy / store.state.suitableScale);
            }
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.top = top;
          store.state.activeComponent.width = width;
          store.state.activeComponent.height = height;
        }

        function moveEnd() {
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 让左下角的圆圈可以改变组件大小和位置
    handleLeftBottomDrag(leftBottom, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      leftBottom.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 设置状态为左下拖拽
        _this.status = 5;

        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;
        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          const dy = ev.clientY - startY;
          startX = ev.clientX;
          startY = ev.clientY;

          let left =
            _this.getPropByStr(dragDiv.style.left) +
            parseInt(dx / store.state.suitableScale);
          let width =
            _this.getPropByStr(dragDiv.style.width) -
            parseInt(dx / store.state.suitableScale);
          let top = _this.getPropByStr(dragDiv.style.top);
          let height =
            _this.getPropByStr(dragDiv.style.height) +
            parseInt(dy / store.state.suitableScale);

          // 不能超过上边界下边界
          if (left < 0 || width < 1) {
            return;
          }

          // 不能超过左边界右边界
          if (height < 1 || top + height > store.state.programInfo.height) {
            return;
          }

          if (store.state.activeComponent.type === "TumengQRCode") {
            if (Math.abs(dx) >= Math.abs(dy)) {
              height = width;
              left =
                _this.getPropByStr(dragDiv.style.left) +
                parseInt(dx / store.state.suitableScale);
            } else {
              width = height;
              left =
                _this.getPropByStr(dragDiv.style.left) -
                parseInt(dy / store.state.suitableScale);
            }
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.left = left;
          store.state.activeComponent.width = width;
          store.state.activeComponent.height = height;
        }

        function moveEnd() {
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 让右下角的圆圈可以改变组件大小和位置
    handleRightBottomDrag(rightBottom, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      rightBottom.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;
        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          const dy = ev.clientY - startY;
          startX = ev.clientX;
          startY = ev.clientY;

          const left = _this.getPropByStr(dragDiv.style.left);
          const top = _this.getPropByStr(dragDiv.style.top);
          let width =
            _this.getPropByStr(dragDiv.style.width) +
            parseInt(dx / store.state.suitableScale);
          let height =
            _this.getPropByStr(dragDiv.style.height) +
            parseInt(dy / store.state.suitableScale);

          // 不能超过上边界下边界
          if (width < 1 || height < 1) {
            return;
          }

          // 不能超过左边界右边界
          if (
            top + height > store.state.programInfo.height ||
            left + width > store.state.programInfo.width
          ) {
            return;
          }

          if (store.state.activeComponent.type === "TumengQRCode") {
            if (Math.abs(dx) >= Math.abs(dy)) {
              height = width;
            } else {
              width = height;
            }
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.width = width;
          store.state.activeComponent.height = height;
        }

        function moveEnd() {
          // 移除事件监听
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 让顶部的圆圈可以改变组件大小和位置
    handleTopDrag(top, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      top.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dy = ev.clientY - startY;
          startY = ev.clientY;

          const top =
            _this.getPropByStr(dragDiv.style.top) +
            parseInt(dy / store.state.suitableScale);
          const height =
            _this.getPropByStr(dragDiv.style.height) -
            parseInt(dy / store.state.suitableScale);

          // 不能超过上边界下边界
          if (top < 0 || height < 0) {
            return;
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.top = top;
          store.state.activeComponent.height = height;
        }

        function moveEnd() {
          // 移除事件监听
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 拖拽右侧中间的圆圈
    handleRightMiddleDrag(rightMiddle, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      rightMiddle.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          startX = ev.clientX;

          const left = _this.getPropByStr(dragDiv.style.left);
          const width =
            _this.getPropByStr(dragDiv.style.width) +
            parseInt(dx / store.state.suitableScale);

          // 不能超过上边界下边界
          if (width < 0) {
            return;
          }

          // 不能超过左边界右边界
          if (left + width > store.state.programInfo.width) {
            return;
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.width = width;
        }

        function moveEnd() {
          // 移除事件监听
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 让底部部的圆圈可以改变组件大小和位置
    handleBottomDrag(bottom, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      bottom.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startY = ev.clientY;

        function move(ev) {
          ev = ev || event;
          const dy = ev.clientY - startY;
          startY = ev.clientY;

          const top = _this.getPropByStr(dragDiv.style.top);
          const height =
            _this.getPropByStr(dragDiv.style.height) +
            parseInt(dy / store.state.suitableScale);

          // 不能超过上边界下边界
          if (height < 0) {
            return;
          }
          if (top + height > store.state.programInfo.height) {
            return;
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.height = height;
        }

        function moveEnd() {
          // 移除事件监听
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },

    // 拖拽左侧中间的圆圈
    handleLeftMiddleDrag(leftMiddle, dragDiv, dragStartFun, dragEndFun) {
      const _this = this;
      //若为价签直接返回
      leftMiddle.onmousedown = function (ev) {
        ev = ev || event;
        if (store.state.multipleComponentList.length) {
          return false;
        }
        // 不让点击事件传播给父级
        ev.stopPropagation();

        let startX = ev.clientX;

        function move(ev) {
          ev = ev || event;
          const dx = ev.clientX - startX;
          startX = ev.clientX;

          const left =
            _this.getPropByStr(dragDiv.style.left) +
            parseInt(dx / store.state.suitableScale);
          const width =
            _this.getPropByStr(dragDiv.style.width) -
            parseInt(dx / store.state.suitableScale);

          // 不能超过上边界下边界
          if (left < 0 || width < 0) {
            return;
          }

          // 改变大小之后要把信息同步到节目中
          store.state.activeComponent.left = left;
          store.state.activeComponent.width = width;
        }

        function moveEnd() {
          // 移除事件监听
          document.removeEventListener("mousemove", move, false);
          document.removeEventListener("mouseup", moveEnd, false);
          dragEndFun && dragEndFun();
        }

        document.addEventListener("mousemove", move, false);
        document.addEventListener("mouseup", moveEnd, false);
        dragStartFun && dragStartFun();
        return false;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable {
  .component-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
.multipleClass {
  > div {
    cursor: inherit !important;
  }
}
</style>
